<template>
  <div>
    <div class="page-actions">
      <span>交易对： </span>
      <el-select v-model="coinType" placeholder="请选择币种">
        <el-option
          v-for="item in coinList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>时间：</span>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="选择日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <span>关键词： </span>
      <el-input v-model="buyId" placeholder="买家ID"></el-input>
      <el-input v-model="sellId" placeholder="卖家ID"></el-input>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
        <span>是否去掉买卖双方都是对公账号的数据: <el-switch v-model="bigSwitch" @change="search"></el-switch></span>
      <a :href="downloadLink" target="_blank">导出Excel</a>
    </div>
    <div class="counts">
      <span></span>
      <span>总数：</span>
      <span></span>
      <span>{{ sumBuyerFee }}</span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span>{{ sumSellerFee }}</span>
      <span></span>
      <span></span>
    </div>
    <el-table :data="currencies">
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column prop="pair" label="交易对"></el-table-column>
      <el-table-column prop="buyerId" label="买家ID"></el-table-column>
      <el-table-column label="买家手续费">
        <template slot-scope="scope">
          {{ scope.row.buyerFee }} {{ scope.row.buyerFeeCoinType }}
        </template>
      </el-table-column>
      <el-table-column prop="dealAmount" label="成交数量"></el-table-column>
      <el-table-column prop="dealDirection" label="主动方方向">
        <template slot-scope="scope">
          <span v-if="scope.row.dealDirection == 'ASK'">卖家主动</span>
          <span v-else>买家主动</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="成交价格"></el-table-column>
      <el-table-column prop="sellerId" label="卖家ID"></el-table-column>
      <el-table-column label="卖家手续费">
        <template slot-scope="scope">
          {{ scope.row.sellerFee }} {{ scope.row.sellerFeeCoinType }}
        </template>
      </el-table-column>
      <el-table-column prop="refSellOrder" label="卖家订单号"></el-table-column>
      <el-table-column prop="refBuyOrder" label="买家 订单号"></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import qs from 'qs';
export default {
  name: 'deal',
  data() {
    return {
      coinType: '',
      date: '',
      buyId: '',
      sellId: '',
      bigSwitch:false
    };
  },

  computed: {
    ...mapState('deal', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList',
      'sumBuyerFee',
      'sumSellerFee'
    ]),
    downloadLink() {
      const data = {
        day: this.date,
        pair: this.coinType,
        buyId: this.buyId,
        sellId: this.sellId,
        ...this.pagination,
        isRemove:this.bigSwitch?1:0,
        status: 1
      };
      const params = qs.stringify(data);
      return `/la/admin/trade/deal?${params}`;
    }
  },
  methods: {
    ...mapActions('deal', ['list']),
    ...mapMutations('deal', ['setpage']),
    search(data) {
      if (!this.date) {
        this.$message({
          message: '时间不能为空！',
          type: 'error'
        });
        return;
      }
      this.list({
        day: this.date,
        pair: this.coinType,
        buyId: this.buyId,
        sellId: this.sellId,
        isRemove:this.bigSwitch?1:0,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', {
        pagination,
        pair: this.coinType,
        sellId: this.sellId,
        day: this.date,
        buyId: this.buyId,
        isRemove:this.bigSwitch?1:0,
      });
    }
  },
  components: {
    Pagination
  }
};
</script>

<style lang="less" scoped>
.el-table {
  ::v-deep.cell {
    text-align: center;
  }
}
.counts {
  display: flex;
  border: 1px solid #ddd;
  span {
    width: 16.6%;
    line-height: 45px;
    border-right: 1px solid #ddd;
    text-align: center;
  }
}
</style>
